import { useState, useEffect } from 'react';
import CustomCursor from '@/components/CustomCursor';
import Loader from '@/components/Loader';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import ParallaxText from '@/components/ParallaxText';
import PromoSection from '@/components/PromoSection';
import DivisionSplit from '@/components/DivisionSplit';
import PainPointSection from '@/components/PainPointSection';
import TargetSection from '@/components/TargetSection';
import ProcessSection from '@/components/ProcessSection';
import WhyUsSection from '@/components/WhyUsSection';
import LatestArticles from '@/components/LatestArticles';
import CTASection from '@/components/CTASection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import PromoPopup from '@/components/PromoPopup';

const Index = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Check if this is first visit
    const hasVisited = sessionStorage.getItem('zofia-visited');
    if (hasVisited) {
      setIsLoading(false);
      setShowLoader(false);
    }
  }, []);

  const handleLoaderComplete = () => {
    setIsLoading(false);
    setShowLoader(false);
    sessionStorage.setItem('zofia-visited', 'true');
  };

  // FAQ Schema for homepage
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Quali servizi offre Zofia Digital Agency?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Offriamo strategia digitale, SEO, web development, social media management, Google Ads, Meta Ads, CRM personalizzati, automazioni AI e analytics per PMI B2B e B2C in tutta Italia."
        }
      },
      {
        "@type": "Question",
        "name": "Per chi sono i servizi di Zofia Digital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "I nostri servizi sono pensati per PMI italiane, sia B2B (software house, consulenti, fornitori industriali) che B2C (ristoranti, negozi, studi professionali, e-commerce)."
        }
      },
      {
        "@type": "Question",
        "name": "Come posso richiedere una consulenza gratuita?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Puoi richiedere una consulenza gratuita compilando il form nella sezione contatti del nostro sito. Ti risponderemo entro 24 ore per fissare un appuntamento."
        }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Zofia Digital Agency | Marketing Digitale per PMI Italiane"
        description="Agenzia di marketing digitale per PMI italiane. Strategia, SEO, web development, social media, ads, CRM e automazioni AI. Risultati misurabili e ROI concreto."
        canonical="/"
        schema={faqSchema}
        keywords="agenzia marketing digitale, marketing PMI Italia, SEO, web development, social media marketing, Google Ads, automazioni AI, CRM personalizzato"
      />

      {/* Custom cursor */}
      <CustomCursor />

      {/* Noise overlay */}
      <div className="noise-overlay" />

      {/* Loader */}
      {showLoader && <Loader onComplete={handleLoaderComplete} />}

      {/* Main content */}
      <div className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-500'}>
        <Navbar />
        
        <main>
          <HeroSection />
          <ParallaxText />
          <PromoSection />
          <DivisionSplit />
          <PainPointSection />
          <TargetSection />
          <ProcessSection />
          <WhyUsSection />
          <LatestArticles />
          <CTASection />
          <ContactSection />
        </main>

        <Footer />
      </div>

      {!isLoading && <PromoPopup />}
    </>
  );
};

export default Index;
